module.exports = __webpack_public_path__ + "assets/eye-test.0521538a.svg";